import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItemList.tsx
var n = ({ className: n, children: r, ...i }) => {
	let a = e("ActionBarItemList", n);
	return /* @__PURE__ */ t("ul", {
		...i,
		className: a,
		children: r
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=ActionBarItemList.js.map